import { render, staticRenderFns } from "./FirmwareForm.vue?vue&type=template&id=6bc62c13&scoped=true&"
import script from "./FirmwareForm.vue?vue&type=script&lang=ts&"
export * from "./FirmwareForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc62c13",
  null
  
)

export default component.exports